<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Lista Ruoli
            </div>
            <div class="grid grid-cols-4 gap-4 mb-3">
                <div class="flex flex-col col-span-2">
                    <Field field_name="Cerca" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_1`]="context">
                        <router-link :to="{name:'DettaglioRuolo', params:{id:context.context.row.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>
            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri ruoli.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Field from "@/components/Field.vue";
import Lista from "@/setup/ListaCerca";
import roleManager from "@/api/Roles";
import Paginator from "@/components/Paginator.vue";

@Options({
    name:'ListaRuoli',
    components: {
        Paginator,
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    }
})
export default class ListaRuoli extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    lista: any = setup(()=>Lista(roleManager, this.cols))
    visible = false

    mounted() {
        this.lista.reset()
    }

    cols = [
        {
            name: 'Nome ruolo',
            prop: 'name',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">

</style>
